import { render, staticRenderFns } from "./commissionFlow.vue?vue&type=template&id=72dc9179&scoped=true&"
import script from "./commissionFlow.vue?vue&type=script&lang=js&"
export * from "./commissionFlow.vue?vue&type=script&lang=js&"
import style0 from "./commissionFlow.vue?vue&type=style&index=0&id=72dc9179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc9179",
  null
  
)

export default component.exports